import familiaComercialRouter from '@/router/cadastros-gerais/familia-comercial.router';
import familiaMaterialRouter from '@/router/cadastros-gerais/familia-material.router';
import condicaoPagamentoRouter from '@/router/cadastros-gerais/condicao-pagamento.router';
import classificacaoFiscalRouter from '@/router/cadastros-gerais/classificacao-fiscal.router';
import itemRouter from '@/router/cadastros-gerais/item.router';
import naturezaOperacaoRouter from '@/router/cadastros-gerais/natureza-operacao.router';
import tipoPedidoRouter from '@/router/cadastros-gerais/tipo-pedido.router';
import tipoPedidoEstabRouter from '@/router/cadastros-gerais/tipo-pedido-estab.router';
import portadorRouter from './portador.router';
import paisRouter from './pais.router';
import cidadeRouter from './cidade.router';
import ufRouter from './uf.router';
import tipoEnderecoRouter from './tipo-endereco.router';
import bancoRouter from './banco.router';
import grupoEstoqueRouter from './grupo-estoque.router';
import unidadeMedidaRouter from './unidade-medida.router';

export default [
  ...portadorRouter,
  ...paisRouter,
  ...cidadeRouter,
  ...ufRouter,
  ...unidadeMedidaRouter,
  ...tipoEnderecoRouter,
  ...bancoRouter,
  ...grupoEstoqueRouter,
  ...familiaComercialRouter,
  ...familiaMaterialRouter,
  ...condicaoPagamentoRouter,
  ...classificacaoFiscalRouter,
  ...tipoPedidoRouter,
  ...tipoPedidoEstabRouter,
  ...naturezaOperacaoRouter,
  ...itemRouter,
];
